import config from '../config/index';
import { request } from './api';
const appId = 'dealer.icsTast';
/**
 * 报价单费用
 */
export default {
  /**
   * 获取报价单费用
   * http://doc.phonebus.corpautohome.com/project/900/interface/api/51300
   * @param appId           调用标识
   * @param cityId          城市id
   * @param specId          车型id
   * @param carPrice        裸车价
   * @param minPrice        厂商指导价
   * @param prepaymentType  首付额度类型
   * @param loanTypeForYear 还款年限
   * @return 报价单费用
   */
  getPriceList(params) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.vrtake + '/api/quote/cost',
      data: { ...params, appId },
      transformResponse: function (data) {
        if (data.returncode === 0) {
          return data;
        } else {
          return data;
        }
      },
    });
  },
  /**
   * 获取活动列表
   * https://doc.autohome.com.cn/docapi/page/lYMF2mmQEq
   * @param appId           调用标识
   * @param dealerId        店铺标识
   * @return 活动列表
   */
  getActivities(dealerId) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.smartStoreApi + '/activities/list/bidding',
      data: { dealerId, _appId: appId },
      transformResponse: function (data) {
        if (data.returncode === 0) {
          return data;
        } else {
          return data;
        }
      },
    });
  },
};
